import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Content from "./content";
import "./Dashboard.css";

const UserDashboard = () => {
  // State to control whether the sidebar is open (for small screens)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle the sidebar (hamburger button)
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Close the sidebar when a menu item is clicked
  const handleSidebarItemClick = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar: pass isOpen & callback for item click */}
      <Sidebar isOpen={isSidebarOpen} onItemClick={handleSidebarItemClick} />

      {/* Main content area */}
      <div className="dashboard-main-content">
        {/* Top bar with hamburger icon – only visible on small screens */}
        <div className="dashboard-topbar">
          <button className="dashboard-hamburger" onClick={toggleSidebar}>
            &#9776; {/* Or any hamburger icon */}
          </button>
        </div>

        {/* The content (child routes rendered here) */}
        <Content />
      </div>
    </div>
  );
};

export default UserDashboard;
